import camelCase from "camelcase";
import { isNull, unset, cloneDeep } from 'lodash'

export function toCamelCaseObj(obj) {
    if (typeof obj === "object" && !Array.isArray(obj)) {
        for (let prop in obj) {
            const newProp = camelCase(prop);
            obj[newProp] = obj[prop];
            if (newProp != prop) {
                unset(obj, prop);
            }
            if (typeof obj[newProp] === "object") {
                toCamelCaseObj(obj[newProp]);
            }
        }
    }
    if (Array.isArray(obj)) {
        for (let value of obj) {
            toCamelCaseObj(isNull(value) ? "" : value);
        }
    }
    return obj;
}

export function camelCaseKeysToUnderscore(obj){
    if (typeof(obj) != "object") return obj;

    obj = cloneDeep(obj)

    for(var oldName in obj){

        // Camel to underscore
        let newName = oldName.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});

        // Only process if names are different
        if (newName != oldName) {
            // Check for the old property name to avoid a ReferenceError in strict mode.
            if (obj.hasOwnProperty(oldName)) {
                obj[newName] = obj[oldName];
                delete obj[oldName];
            }
        }

        // Recursion
        if (typeof(obj[newName]) == "object") {
            obj[newName] = camelCaseKeysToUnderscore(obj[newName]);
        }

    }
    return obj;
}
